// Registro y opciones base compartidas por todos los gráficos de Reportes Recepción.
import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement,
    ArcElement, Title, Tooltip, Legend,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { COLOR, FUENTE } from './tokens';

ChartJS.register(
    CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement,
    Title, Tooltip, Legend, annotationPlugin
);

// Grilla solo horizontal, sin borde de eje, sin grilla vertical — regla de diseño
// obligatoria del prompt base. Cada gráfico hace merge de esto con sus propias
// escalas (colores por umbral, ejes secundarios, etc).
export const BASE_OPTIONS = {
    responsive: true,
    maintainAspectRatio: false,
    font: { family: FUENTE },
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                font: { family: FUENTE, size: 12, weight: '500' },
                color: COLOR.grisTexto,
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 10,
                boxHeight: 10,
            },
        },
        tooltip: {
            enabled: true,
            backgroundColor: 'rgba(20,24,29,0.95)',
            titleFont: { family: FUENTE, size: 13, weight: '600' },
            bodyFont: { family: FUENTE, size: 12 },
            padding: 12,
            cornerRadius: 8,
        },
    },
};

export const EJE_X_BASE = {
    grid: { display: false },
    border: { display: false },
    ticks: { font: { family: FUENTE, size: 11 }, color: COLOR.grisTexto },
};

export const EJE_Y_BASE = {
    grid: { color: COLOR.gris, drawTicks: false },
    border: { display: false },
    ticks: { font: { family: FUENTE, size: 11 }, color: COLOR.grisTexto },
};

// Línea de referencia (meta / capacidad / promedio) vía chartjs-plugin-annotation.
// La posición SIEMPRE se calcula desde datos reales — nunca un valor ni una
// posición porcentual fija en el componente que llama a esto.
export function lineaAnotacion(valor, color, texto, { eje = 'y', dash = [4, 4] } = {}) {
    const eje2 = eje === 'y' ? { yMin: valor, yMax: valor } : { xMin: valor, xMax: valor };
    return {
        type: 'line',
        ...eje2,
        borderColor: color,
        borderWidth: 1.5,
        borderDash: dash,
        label: {
            display: true,
            content: texto,
            position: 'end',
            backgroundColor: color,
            color: '#fff',
            font: { family: FUENTE, size: 10, weight: '600' },
            padding: { x: 6, y: 2 },
        },
    };
}

// Formato "331 · 59,1%" para tooltips/labels que combinan valor absoluto + %.
export function formatoValorPct(valor, pct) {
    const pctFmt = typeof pct === 'number' ? pct.toLocaleString('es-AR', { maximumFractionDigits: 1 }) : '—';
    return `${valor.toLocaleString('es-AR')} · ${pctFmt}%`;
}
